{ "id": "anneau-aventurier", "name": "Anneau de l'Aventurier", "slot": "anneau", "set": "aventurier", "tier": 1, "price": 40, "icon": "icons/items/anneau-aventurier", "stats": { "force": 5, "intelligence": 5, "chance": 5, "agilite": 5 } }
